import { getToken, onMessage } from "firebase/messaging";
import { useEffect, useRef, useState } from "react";
import { Route, Routes, useLocation, useRoutes } from "react-router-dom";
import { messaging } from "./firebase";
import { BottomSheetChat, MessagesError, MessagesSign, MessagesSuccess, } from "./components";
import MessageActivate from "./components/Messages/MessageActivate";
import PackageLink from "./components/PackageLink";
import PopUpImages from "./components/PopUps/PopUpImages";
import UseScrollRestoration from "./components/useScrollRestoration";
import { useContextChat } from "./Context/ContextChat";
import { dataPageMembers, dataUserOperations } from "./Context/lists";
import { useContextHook } from "./Context/ContextOPen";
import { content } from "./Context/translate";
import AudioFile from "./images/smallmessag_93143d2d5268411.mp3";
import * as layout from "./layout";
import * as page from "./pages";
import SimpleSignUp from "./pages/Auth/SimpleSignUp";
import ViewProfile from "./pages/Members/ViewProfile";
import Packages from "./pages/packages";
import Payment from "./pages/packages/payment";
import { RequireAuth, RequireLogin, checkToken, useFETCH } from "./Tools/APIs";
import * as Error from "./Tools/Error";
import { Col, Container, Row } from "./Tools/Grid-system";

const App = () => {
    const {
        setNewMessage, setChatDelelete, setMessageRead,
        setMessageDelete, setLoadingCounter, setIsActive,
    } = useContextChat();
    const { pathname } = useLocation();
    const refAudio = useRef();
    const scrollRef = useRef(null);
    const { showBottomSheet, setShowBottomSheet } = useContextHook();
    
    const [profileRefresh, setProfileRefresh] = useState(0);

    onMessage(messaging, (payload) => {
        if (+pathname.substring(6) === +payload?.data?.user) {
        } else if (payload.notification.title === "chat deletion event") {
            return setChatDelelete(payload?.data?.user_id);
        } else if (payload.notification.title === "message deletion event") {
            return setMessageDelete(payload?.data?.message_id);
        } else if (payload.notification.title === "message read event") {
            return setMessageRead(payload?.data?.user_id);
        } else {
            if (refAudio.current) {
                refAudio.current.play();
                setNewMessage({
                    reload: payload?.data?.created_at,
                });
            }
        }
    });

    async function requestPermission() {
        const prem = await Notification.requestPermission();
        if (prem === "granted") {
            const fcm_token = await getToken(messaging, {
                vapidKey:
                    "BDgmQzQGM34ZCN770v5l4cnti7mmQg8rTYjzbnnatNFHL18bZHqcJrfwLVhOXmPA-umV1mGhZzD2VQMfsk9OQaQ",
            });
            sessionStorage.setItem("fcm_token", fcm_token);
        }
    }

    useEffect(() => {
        requestPermission();
    }, []);

    const [notificationRingState, setNotificationRingState] = useState(1);
    const refresh = useRef(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setNotificationRingState((prev) => prev + 1);
        }, 8000);
        return () => clearInterval(interval);
    }, []);

    const [readNotifications, setReadNotifications] = useState(0);
    
    const { data, isLoading } = useFETCH(
        checkToken && `v1/profile?ring=${notificationRingState}&read=${readNotifications}&refresh=${profileRefresh}`
    );

    useEffect(() => {
        setIsActive(data?.data?.data?.is_active);
    }, [data?.data?.data?.is_active, setIsActive]);

    useEffect(() => {
        if (data?.data?.notifications_count > 0 && localStorage.getItem("notified_on") !== data?.data?.notifications?.data[0]?.id) {
            const audio = new Audio(AudioFile);
            audio.play().catch((error) => console.log(error));
            localStorage.setItem(
                "notified_on",
                data?.data?.notifications?.data[0]?.id
            );
        }
        if (data?.data?.notifications_count === 0) {
            setReadNotifications(0);
        }
        setLoadingCounter((prev) => prev + 1);
    }, [data, setLoadingCounter]);

    const prevLocation = useRef(pathname);

    useEffect(() => {
        if (pathname === "/profile/notifications" && prevLocation.current !== "/profile/notifications") {
            setReadNotifications(1);
        } else if (pathname !== "/profile/notifications") {
            setReadNotifications(0);
        }
        prevLocation.current = pathname; 
    }, [pathname]);

    return (
        <div className="max-md:h-screen flex relative flex-col max-md:overflow-y-hidden">
            <audio ref={refAudio}>
                <source src={AudioFile} type="audio/mpeg" />
            </audio>
            <UseScrollRestoration />
            <PackageLink />
            <MessagesSuccess />
            <MessagesError />
            <MessagesSign />
            <MessageActivate />
            <BottomSheetChat isOpen={showBottomSheet[1]} id={showBottomSheet[0]} setShowBottomSheet={setShowBottomSheet} />
            <PopUpImages profileImages={data?.data.data.images} />
            <layout.NavBar data={data} />
            <div ref={scrollRef} className="max-md:h-[80vh] flex-1 max-md:overflow-y-scroll">
                <Routes>
                    <Route element={<RequireLogin />}>
                        {!checkToken && <Route path="/" element={<page.Home propsData={data} isLoading={isLoading} />} />}
                        <Route path="admin/sign-in/:token" element={<page.CreateToken />} />
                        <Route path="auth">
                            <Route path="sign-in" element={<page.Login />} />
                            <Route path="sign-up" element={<SimpleSignUp />} />
                            <Route path="forget-password" element={<page.ForgetPassword />} />
                            <Route path="verification-code" element={<page.VerificationCode />} />
                            <Route path="set-password" element={<page.SetPassword />} />
                        </Route>
                    </Route>
                </Routes>
                { (pathname === "/" && !checkToken) || pathname.startsWith("/auth") || pathname.includes("/admin/sign-in/")
                    ? null
                    : (
                        <Container>
                            <br />
                            <Row className="max-md:h-[90vh]">
                                <Col md={3} className={`${pathname.startsWith("/packages") || pathname === '/payment' ? "hidden" : ""} max-sm:hidden relative`}>
                                    <layout.SideBarUser data={data} />
                                </Col>
                                <Col md={pathname.startsWith("/packages") || pathname === '/payment' ? 12 : 9} className="md:!pl-5">
                                    <Routes>
                                        {checkToken && (
                                            <Route path="/" element={<page.Home propsData={data} isLoading={isLoading} />} />
                                        )}
                                        <Route path="view-profile/:id" element={<ViewProfile />} />
                                        <Route path="account-activation" element={<page.ActivateAccount />} />
                                        <Route path="/packages" element={<Packages />} />
                                        <Route path="/mypackages" element={<page.MyPackages />} />
                                        <Route path="/payment" element={<Payment />} />

                                        <Route element={<RequireAuth />}>
                                            <Route path="chat" element={<page.Inbox data={data} />}>
                                                <Route path=":id" element={<page.Chats />} />
                                                <Route path="err/403" element={<Error.P403 />} />
                                            </Route>
                                        </Route>

                                        <Route path="search" element={<page.Search />}>
                                            <Route index element={<page.NameSearch />} />
                                            <Route path="advanced" element={<page.AdvancedSearch />} />
                                            <Route path="quick" element={<page.QuickSearch />} />
                                        </Route>

                                        <Route path="search/users" element={<page.SearchUser />} />

                                        <Route element={<RequireAuth />}>
                                            <Route path="settings" element={<page.Settings />}>
                                                <Route index element={<page.GeneralSettings />} />
                                                <Route path="chat" element={<page.ChatSettings />} />
                                                <Route path="notifications" element={<page.NotificationsSettings />} />
                                            </Route>

                                            <Route path="user-images" element={<page.UsersImages />}>
                                                <Route index element={<page.RoleImages />} />
                                                <Route path="members-images" element={<page.MembersImages />} />
                                                <Route path="my-images" element={<page.Myphotos id={data?.data?.data?.login_details?.id} />} />
                                            </Route>
                                            
                                            <Route path="profile">
                                                <Route index element={<page.PersonalFile data={data} isLoading={isLoading} />} />
                                                
                                                {}
                                                <Route path="edit" element={<page.UpdateProfile onProfileUpdate={() => setProfileRefresh(p => p + 1)} />} />
                                                
                                                <Route path="notifications" element={<page.Notifications propsData={data?.data} isLoading={isLoading} />} />
                                            </Route>
                                        </Route>
                                    </Routes>
                                    <DataPages />
                                </Col>
                            </Row>
                        </Container>
                    )
                }
            </div>
            <layout.Footer />
        </div>
    );
};

export default App;

const DataPages = () => {
    const pages = [
        { path: "about-us", element: <page.AboutUs name={content.AboutUs} /> },
        { path: "site-terms", element: <page.AboutUs name={content.SiteTermsAndConditions} /> },
        { path: "contact-us", element: <page.ContactUs /> },
        { path: "privacy-policy", element: <page.PrivacyPolicy /> },
        { path: "help", element: <page.QuestionCategories type="HELP_CENTER" title={content.Help} /> },
        { path: "help/:sectionId/:id", element: <page.SingleQuestion type={content.Help} /> },
        { path: "faqs", element: <page.QuestionCategories type="FAQS" title={content.CommonQuestions} /> },
        { path: "faqs/:sectionId/:id", element: <page.SingleQuestion type={content.FAQ} /> },
        { path: "blog", element: <page.Blog /> },
        { path: "blog/:slug", element: <page.SingleBlog /> },
    ];
    const [userRoutes, setUserRoutes] = useState([]);
    useEffect(() => {
        setUserRoutes(
            dataUserOperations.map((e) => ({
                path: e.path,
                element: <page.UserOperations actionApi={e.actionApi} api={e.api} title={e.title} />,
            })).concat(
                dataPageMembers.map((e) => ({
                    path: e.path,
                    element: <page.Members category={e.category} title={e.title} desc={e.desc} />,
                }))
            ).concat([
                { path: "pro", element: <page.ProUsers /> }
            ]).concat(
                pages.map((e) => ({ path: e.path, element: e.element }))
            )
        );
    }, []);

    let routes = useRoutes(userRoutes);
    return routes;
};